import { SelectTableFilter } from "./SelectTableFilter";
import { DateRangeTableFilter } from "./DateRangeTableFilter";

export const tableFilters = {
  select: SelectTableFilter,
  "date-range": DateRangeTableFilter
};
